export const validateDateRange = (startYear, startMonth, endYear, endMonth) => {
  const monthsMap = {
    'January': 1, 'February': 2, 'March': 3, 'April': 4, 'May': 5, 'June': 6,
    'July': 7, 'August': 8, 'September': 9, 'October': 10, 'November': 11, 'December': 12
  };

  if (endYear === 'Present' || endMonth === 'Present') {
    return true;
  }

  if (startYear && endYear) {
    if (startYear > endYear) return false;
    if (startYear === endYear && monthsMap[startMonth] > monthsMap[endMonth]) {
      return false;
    }
  }

  return true;
};

export const formatDate = (dateString) => {
  if (!dateString) return ''; // If the date is not available
  const date = new Date(dateString);
  const month = date.toLocaleString('default', { month: 'long' }); // Get full month name
  const year = date.getFullYear(); // Get year
  return `${month} ${year}`; // Return "Month Year"
}

export const formatTimeAmPm = (time) => {
  if (!time) return '';
  const [hour, minute] = time.split(':');
  const hourNum = parseInt(hour, 10);
  const ampm = hourNum >= 12 ? 'PM' : 'AM';
  const formattedHour = hourNum % 12 || 12;
  return `${formattedHour}:${minute} ${ampm}`;
};

export const getReadableFileTypes = (accept) => {
  const mimeToLabelMap = {
    "image/jpeg": "JPEG",
    "image/png": "PNG",
    "application/pdf": "PDF",
    'video/mp4': "MP4",
    'application/msword': "DOC",
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': "DOCX",
    "eml": "EML",
    "message/rfc822": "EML", // Avoid repetition
  };

  // Remove duplicates and return formatted string
  const uniqueFileTypes = [...new Set(accept.map(type => mimeToLabelMap[type] || type))];
  return uniqueFileTypes;
};

export const checkEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) && !email.includes(" ");
}

export const sortListByDate = (list, type) => {
  // console.log("Education List", list, "Type ", type);
  const sortConfig = {
    experience: {
      isCurrentlyActive: 'is_currently_working',
      startYear: 'start_year',
      startMonth: 'start_month',
      endYear: 'end_year',
      endMonth: 'end_month'
    },
    education: {
      isCurrentlyActive: 'is_pursuing',
      startYear: 'start_year',
      endYear: 'end_year'
    },
    certificates: {
      month: 'issue_date',
      year: 'year',
    },
    projects: {
      isCurrentlyActive: 'currentlyWorking',
      startYear: 'start_year',
      startMonth: 'start_month',
      endYear: 'end_year',
      endMonth: 'end_month'
    },
    awards: {
      year: 'issue_year', // Only has year and month
      month: 'issue_month',
    }
    // Add other configurations as needed
  };

  const monthOrder = {
    'January': 1, 'February': 2, 'March': 3, 'April': 4, 'May': 5, 'June': 6,
    'July': 7, 'August': 8, 'September': 9, 'October': 10, 'November': 11, 'December': 12
  };

  const config = sortConfig[type]; // Get the config for the specific type

  if (!config) {
    console.error(`No sorting configuration found for type: ${type}`);
    return list;
  }

  return list?.sort((a, b) => {
    // If only year and month are present (certificates/awards)
    if (config.year && config.month) {
      const yearComparison = parseInt(b[config.year]) - parseInt(a[config.year]);
      if (yearComparison !== 0) return yearComparison;

      // Compare months if the year is the same
      const monthComparison = (monthOrder[b[config.month]] || 0) - (monthOrder[a[config.month]] || 0);
      return monthComparison;
    }

    // Check if isCurrentlyActive is present in the config
    if (config.isCurrentlyActive) {
      const aIsActive = a[config.isCurrentlyActive] ? 1 : 0;
      const bIsActive = b[config.isCurrentlyActive] ? 1 : 0;
      if (aIsActive !== bIsActive) return bIsActive - aIsActive;
    }

    // More recent start date
    const startYearComparison = parseInt(b[config.startYear]) - parseInt(a[config.startYear]);
    if (startYearComparison !== 0) return startYearComparison;

    if (config.startMonth) {
      const startMonthComparison = (monthOrder[b[config.startMonth]] || 0) - (monthOrder[a[config.startMonth]] || 0);
      if (startMonthComparison !== 0) return startMonthComparison;
    }

    // More recent end date for inactive items
    if (!a[config.isCurrentlyActive] && !b[config.isCurrentlyActive]) {
      if (config.endYear) {
        const endYearComparison = parseInt(b[config.endYear]) - parseInt(a[config.endYear]);
        if (endYearComparison !== 0) return endYearComparison;
      }

      if (config.endMonth) {
        const endMonthComparison = (monthOrder[b[config.endMonth]] || 0) - (monthOrder[a[config.endMonth]] || 0);
        return endMonthComparison;
      }
    }

    return 0; // No difference
  });
};
